import {
  GET_ONBOARDING_QUESTIONS,
  SUBMIT_ONBOARDING_ANSWERS,
  CHECK_ONBOARDING_STATUS,
  ONBOARDING_LOADING,
  CLEAR_ONBOARDING
} from '../actions/types';

const initialState = {
  questions: [],
  programTitle: '',
  hasCompletedOnboarding: false,
  hasGroup: false,
  assignedPath: null,
  result: null,
  loading: false
};

export default function onboardingReducer(state = initialState, action) {
  switch (action.type) {
    case ONBOARDING_LOADING:
      return {
        ...state,
        loading: true
      };
    case GET_ONBOARDING_QUESTIONS:
      return {
        ...state,
        questions: action.payload.questions,
        programTitle: action.payload.programTitle,
        loading: false
      };
    case SUBMIT_ONBOARDING_ANSWERS:
      return {
        ...state,
        result: action.payload,
        hasCompletedOnboarding: true,
        assignedPath: action.payload.assignedPath,
        loading: false
      };
    case CHECK_ONBOARDING_STATUS:
      return {
        ...state,
        hasCompletedOnboarding: action.payload.hasCompletedOnboarding,
        hasGroup: action.payload.hasGroup,
        assignedPath: action.payload.assignedPath,
        loading: false
      };
    case CLEAR_ONBOARDING:
      return initialState;
    default:
      return state;
  }
}
